import React, { createContext } from 'react';
import { VisibleCards } from 'spw-programming-projects/reports/exportables/hooks';

export const ProgramSummaryContext = createContext<{
  visibleCards: VisibleCards;
  setVisibleCards: React.Dispatch<React.SetStateAction<VisibleCards>>;
}>({
  visibleCards: null,
  setVisibleCards: null,
});
